import styled from '@emotion/styled'

export default styled.h2`
	display: inline-block;
	text-transform: uppercase;
	color: var(--clr-dark);
	border-bottom: 3px solid;
	padding-bottom: calc(var(--spacing) / 2);
`
